import { useCallback } from 'react';
import { Bot } from 'lucide-react';
import { reportApi } from '../../services/reportApi';
import { AgentChat } from '../shared/AgentChat';

export default function ReportChat({
  selectedCompanies,
  onSelectCompany,
  onRemoveCompany,
  onWorkspaceAction,
  onThreadCreated,
  threadId: externalThreadId,
}) {
  const handleCustomEvent = useCallback((eventType, data) => {
    if (eventType === 'workspace_action') {
      if (onWorkspaceAction) onWorkspaceAction(data.data || data);
      return true;
    }
    return false;
  }, [onWorkspaceAction]);

  const buildContext = useCallback((companies, threadId) => ({
    selected_rf_ids: companies.map(c => c.rf_id),
    selected_companies: companies.map(c => ({
      rf_id: c.rf_id, name: c.company_name, source_type: c.source_type,
    })),
    org_id: 'default',
    thread_id: threadId || undefined,
  }), []);

  const emptyState = (handleSend) => (
    <>
      <Bot size={28} className="text-accent/30 mb-3" />
      <p className="text-sm text-zinc-400 mb-4">I can help you create and reconcile financial reports.</p>
      <div className="space-y-2 w-full max-w-xs">
        {[
          'Create a P&L report for 2025',
          'Run a balance sheet and reconcile it',
          'Show me cash flow split by department',
        ].map(prompt => (
          <button
            key={prompt}
            onClick={() => handleSend(prompt)}
            className="w-full text-left px-3 py-2 text-xs text-zinc-500 border border-zinc-200 rounded-lg hover:bg-zinc-50 hover:text-zinc-700 transition-colors"
          >
            {prompt}
          </button>
        ))}
      </div>
    </>
  );

  return (
    <AgentChat
      api={reportApi}
      agentName="Report Agent"
      threadId={externalThreadId}
      onThreadCreated={onThreadCreated}
      selectedCompanies={selectedCompanies}
      onSelectCompany={onSelectCompany}
      onRemoveCompany={onRemoveCompany}
      buildContext={buildContext}
      onCustomEvent={handleCustomEvent}
      header={null}
      emptyState={emptyState}
      placeholder="Ask about reports, reconciliation..."
      compact
    />
  );
}
